import { createReducer } from '@reduxjs/toolkit'
import * as invoicesAction from '../actions/invoices'
import { APIData, APIStatus } from '../axiosConfiguration'
import { InvoiceData, InvoiceDocuments } from '../type/invoices'

type InvoiceSearchState = {
  info: APIData<InvoiceData>,
  invoiceDocumentData: APIData<InvoiceDocuments>

}

const initialState: InvoiceSearchState = {
  info: { status: APIStatus.IDLE },
  invoiceDocumentData: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(invoicesAction.getInvoiceData.fulfilled, (state, action) => {
      state.info.status = APIStatus.FULFILLED
      state.info.data = action.payload
    })
    .addCase(invoicesAction.getInvoiceData.rejected, (state, action) => {
      state.info.status = APIStatus.REJECTED
      state.info.error = action.payload
    })
    .addCase(invoicesAction.getInvoiceData.pending, (state) => {
      state.info.status = APIStatus.PENDING
    })

  builder
    .addCase(invoicesAction.getInvoiceDocument.fulfilled, (state, action) => {
      state.invoiceDocumentData.status = APIStatus.FULFILLED
      state.invoiceDocumentData.data = action.payload
    })
    .addCase(invoicesAction.getInvoiceDocument.rejected , (state, action) => {
      state.invoiceDocumentData.status = APIStatus.REJECTED
      state.invoiceDocumentData.error = action.payload
    })
    .addCase(invoicesAction.getInvoiceDocument.pending, (state, action) => {
      state.invoiceDocumentData.status = APIStatus.PENDING
    })
})
